import { boolean, date, jsonb, pgTable, text, varchar } from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

export const visaStatus = pgTable('visa_status', {
  id: id(),
  userId: text('user_id').notNull().unique(),
  pathway: varchar('pathway', { length: 32 }).notNull(),
  stage: varchar('stage', { length: 32 }).notNull(),
  subclass: varchar('subclass', { length: 16 }),
  expectedWorkRightsDate: date('expected_work_rights_date'),
  bridgingGranted: boolean('bridging_granted').default(false).notNull(),
  sponsorRequiredOverride: boolean('sponsor_required_override'),
  maraAgent: jsonb('mara_agent'),
  notes: text('notes'),
  ...timestamps,
});

export const visaMilestones = pgTable('visa_milestones', {
  id: id(),
  userId: text('user_id').notNull(),
  milestoneType: varchar('milestone_type', { length: 48 }).notNull(),
  occurredOn: date('occurred_on'),
  expectedOn: date('expected_on'),
  details: jsonb('details'),
  ...timestamps,
});
